<template>
  <v-card class="d-flex flex-column justify-center h-100">
    <div class="p-3 w-100 d-flex flex-column flex-md-row align-items-center justify-content-center border-bottom">
      <h6 class="m-0 p-0 font-weight-bold">
        Desafio
      </h6>
    </div>
    <OnCycle
      v-if="!cycle.is_finished && has_challenges"
      :cycle="cycle"
    />
    <AfterCycle
      v-else-if="cycle.is_finished && has_challenges"
      :cycle="cycle"
    />
    <NoChallenge
      v-else
      :cycle="cycle"
    />
  </v-card>
</template>
<script>

import OnCycle from "./ChallengeColumn/OnCycle";
import AfterCycle from "./ChallengeColumn/AfterCycle";
import NoChallenge from "./ChallengeColumn/NoChallenge";

export default {
  components: {
    OnCycle,
    NoChallenge,
    AfterCycle,
  },
  props: {
    cycle: {
      type: Object,
      required: true
    },
  },
  computed: {
    has_challenges(){
      return this.cycle.challenge
    }
  },
}
</script>
